var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"top"},[_c('pmainVis'),_c('pnews'),_c('pinfo'),_c('pxfd'),_c('ppv'),_c('pcredit')],1)}
var staticRenderFns = []

export { render, staticRenderFns }